/**
 * check login or not
 */
export const paginationPages = [5, 10, 20, 50];

export const paginationLimit = { page: 1, limit: 20 };

export const selectTime = [
  { value: "00:00:00", label: "12:00 AM" },
  { value: "00:30:00", label: "12:30 AM" },
  { value: "01:00:00", label: "01:00 AM" },
  { value: "01:30:00", label: "01:30 AM" },
  { value: "02:00:00", label: "02:00 AM" },
  { value: "02:30:00", label: "02:30 AM" },
  { value: "03:00:00", label: "03:00 AM" },
  { value: "03:30:00", label: "03:30 AM" },
  { value: "04:00:00", label: "04:00 AM" },
  { value: "04:30:00", label: "04:30 AM" },
  { value: "05:00:00", label: "05:00 AM" },
  { value: "05:30:00", label: "05:30 AM" },
  { value: "06:00:00", label: "06:00 AM" },
  { value: "06:30:00", label: "06:30 AM" },
  { value: "07:00:00", label: "07:00 AM" },
  { value: "07:30:00", label: "07:30 AM" },
  { value: "08:00:00", label: "08:00 AM" },
  { value: "08:30:00", label: "08:30 AM" },
  { value: "09:00:00", label: "09:00 AM" },
  { value: "09:30:00", label: "09:30 AM" },
  { value: "10:00:00", label: "10:00 AM" },
  { value: "10:30:00", label: "10:30 AM" },
  { value: "11:00:00", label: "11:00 AM" },
  { value: "11:30:00", label: "11:30 AM" },
  { value: "12:00:00", label: "12:00 PM" },
  { value: "12:30:00", label: "12:30 PM" },
  { value: "13:00:00", label: "01:00 PM" },
  { value: "13:30:00", label: "01:30 PM" },
  { value: "14:00:00", label: "02:00 PM" },
  { value: "14:30:00", label: "02:30 PM" },
  { value: "15:00:00", label: "03:00 PM" },
  { value: "15:30:00", label: "03:30 PM" },
  { value: "16:00:00", label: "04:00 PM" },
  { value: "16:30:00", label: "04:30 PM" },
  { value: "17:00:00", label: "05:00 PM" },
  { value: "17:30:00", label: "05:30 PM" },
  { value: "18:00:00", label: "06:00 PM" },
  { value: "18:30:00", label: "06:30 PM" },
  { value: "19:00:00", label: "07:00 PM" },
  { value: "19:30:00", label: "07:30 PM" },
  { value: "20:00:00", label: "08:00 PM" },
  { value: "20:30:00", label: "08:30 PM" },
  { value: "21:00:00", label: "09:00 PM" },
  { value: "21:30:00", label: "09:30 PM" },
  { value: "22:00:00", label: "10:00 PM" },
  { value: "22:30:00", label: "10:30 PM" },
  { value: "23:00:00", label: "11:00 PM" },
  { value: "23:30:00", label: "11:30 PM" },
  { value: "23:59:00", label: "11:59 PM" },
];

export const timeSlots = [
  { value: "00:00:00-01:00:00", label: "12:00 AM - 01:00 AM" },
  { value: "01:00:00-02:00:00", label: "01:00 AM - 02:00 AM" },
  { value: "02:00:00-03:00:00", label: "02:00 AM - 03:00 AM" },
  { value: "03:00:00-04:00:00", label: "03:00 AM - 04:00 AM" },
  { value: "04:00:00-05:00:00", label: "04:00 AM - 05:00 AM" },
  { value: "05:00:00-06:00:00", label: "05:00 AM - 06:00 AM" },
  { value: "06:00:00-07:00:00", label: "06:00 AM - 07:00 AM" },
  { value: "07:00:00-08:00:00", label: "07:00 AM - 08:00 AM" },
  { value: "08:00:00-09:00:00", label: "08:00 AM - 09:00 AM" },
  { value: "09:00:00-10:00:00", label: "09:00 AM - 10:00 AM" },
  { value: "10:00:00-11:00:00", label: "10:00 AM - 11:00 AM" },
  { value: "11:00:00-12:00:00", label: "11:00 AM - 12:00 PM" },
  { value: "12:00:00-13:00:00", label: "12:00 PM - 01:00 PM" },
  { value: "13:00:00-14:00:00", label: "01:00 PM - 02:00 PM" },
  { value: "14:00:00-15:00:00", label: "02:00 PM - 03:00 PM" },
  { value: "15:00:00-16:00:00", label: "03:00 PM - 04:00 PM" },
  { value: "16:00:00-17:00:00", label: "04:00 PM - 05:00 PM" },
  { value: "17:00:00-18:00:00", label: "05:00 PM - 06:00 PM" },
  { value: "18:00:00-19:00:00", label: "06:00 PM - 07:00 PM" },
  { value: "19:00:00-20:00:00", label: "07:00 PM - 08:00 PM" },
  { value: "20:00:00-21:00:00", label: "08:00 PM - 09:00 PM" },
  { value: "21:00:00-22:00:00", label: "09:00 PM - 10:00 PM" },
  { value: "22:00:00-23:00:00", label: "10:00 PM - 11:00 PM" },
  { value: "23:00:00-00:00:00", label: "11:00 PM - 12:00 PM" },
];
